// ROLES
/*eslint-disable*/
export const PRINCIPAL_ROLE = 'principal'
export const PARENT_ROLE = 'parent'
export const TEACHER_ROLE = 'teacher'
export const ADMIN_ROLE = 'admin'
export const defaultProfileImage = 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png'

export const HIGH_TEMPERATURE = 37.7

export const CLASSROOM_TYPE_COLOR = {
    "Sick Room": '#DC001B',
    active: 'white',
    inactive: '#CCCCCC',
}

export const CLASSROOM_TYPE_COLOR_HOVER = {
    "Sick Room": '#bdbdbd',
    active: '#0071b5',
    inactive: '#bdbdbd',
}

export const CLASSROOM_TYPE_COLOR_BACKGROUND = {
    inactive: '#D8D8D8',
    "Sick Room": '#D8D8D8',
    active: '#008CE0',
}

export const CLASSROOM_TYPE_COLOR_INFO = {
    inactive: '#4A4A4A',
    "Sick Room": '#4A4A4A',
    active: 'white',
}

export const CLASSROOM_TYPE_ICON = {
    inactive: 'assets/people_icon.svg',
    "Sick Room": 'assets/symptom_icon.svg',
    active: 'assets/people_icon.svg',
}

export const CHILDREN_STATUS_SMALL_DIV = {
    Advenio: '#75B753',
    'Virtual Center - Advenio': '#75B753',
    Inactive: 'gray',
    Home: '#EAEAEA',
    External: '#EAEAEA',
    "Nurse's Room": '#D0021B',
    "Virtual Center - Nurse's Room": '#D0021B',
}

export const CHILDREN_STATUS_SMALL_INNER_DIV = {
    Advenio: '#75B753',
    Inactive: 'white',
    Home: 'white',
    "Nurse's Room": '#D0021B',
}

export const STATUS_DIV = {
    Advenio: 'white',
    Inactive: '#cbcbcb',
    Home: '#cbcbcb',
    "Nurse's Room": '#D0021B',
}

export const CHILDRENS_DIV = {
    Advenio: 'white',
    Inactive: '#cbcbcb',
    Home: '#cbcbcb',
    "Nurse's Room": 'white',
    'Checkout': '#ffe5e5',
}
export const CHILDRENS_LIST_TAB = {
    todos: 'Todos',
    presentes: 'Presentes',
    ausentes: 'Ausentes',
}
export const TABS_STUDENT_PROFILE = {
    recent_activity: 'Actividad Reciente',
    activities: 'Actividades',
    profile: 'Perfil',
    evaluation: "Desarrollo",
    documents: 'Documentos',
    contract: 'Convenios',
    gallery: 'Fotos',
    cards: 'Tarjetas',
    history: 'Historial',
    balance: 'Estado de cuenta',
    invoices: 'Facturas',
    receipts: 'Recibos',
    notification: 'Notificaciones',
}

export const PROFILE_PANEL_LABELS = {
    inventario: 'INVENTORY',
    hours: 'Horas',
    diapers: 'Pañales',
    parents: 'PADRES',
    borthers: 'HERMANOS',
    check_in: 'Formato de entrada',
    daily_val: 'Agregar valoracion diaria',
    report_issue: 'Reportar Incidente',
    logout: 'Cerrar Sesion',
}

export const BACK_OFFICE_ROLES = ['Back Office Admin','Back Office Assistant','Back Office MiAdvenio','Back Office Talisis', 'Super Admin']
export const OFFICE_CENTER_ROLES = ['Director', 'Coordinator', 'Receptionist']
export const CLASSROOM_ROLES = ['Teacher', 'Nurse']
export const PARENT_ROLES = ['Parent']
export const BACK_OFFICE_CENTER_ROLES = BACK_OFFICE_ROLES.concat(OFFICE_CENTER_ROLES)
export const COMING_CHECKOUT_SSE_ROLES = ['Director', 'Coordinator', 'Teacher']
export const HOURS_LIMIT = [
    { "id": 0, "label": "seleccione", "value": 0 },
    { "id": 1, "label": "1 - hora", "value": 1 },
    { "id": 2, "label": "2 - hora", "value": 2 },
    { "id": 3, "label": "3 - hora", "value": 3 },
    { "id": 4, "label": "4 - hora", "value": 4 },
    { "id": 5, "label": "5 - hora", "value": 5 },
    { "id": 6, "label": "6 - hora", "value": 6 },
    { "id": 7, "label": "7 - hora", "value": 7 },
    { "id": 8, "label": "8 - hora", "value": 8 },
    { "id": 9, "label": "9 - hora", "value": 9 },
    { "id": 10, "label": "10 - hora", "value": 10 },
    { "id": 11, "label": "11 - hora", "value": 11 },
    { "id": 12, "label": "12 - hora", "value": 12 }
]
export const ADD_ACTIVITY = 'Agregar Actividad'

export const VIEW_MORE = 'Ver más...'



// WEBPACK FOOTER //
// ./src/Constants.js